// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-tree-node{flex:1;align-items:center;font-size:14px;padding-right:8px}.class-container,.custom-tree-node{display:flex;justify-content:space-between}.class-container{width:700px;padding:10px 30px 20px 20px;flex-direction:row;align-content:center}.class-content{font-size:14px}", ""]);
// Exports
module.exports = exports;
